<template><!-- mobile -->
    <section>
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     @review="handleReview"
                     :btn_add="canAdd"
                     btn_review
                     past
        >
        </front-table>
        <!--编辑界面-->
        <meeting-view :view_mode="view_mode" :single="single" @start="startMeeting" @mail="mailAttendees" btn_modify
                      :mobile="true" @cancel="view_mode = false">
        </meeting-view>

        <div v-show="show_table" ref="excel_table">
            <el-table border size="small"
                      :data="table.data" show-summary
                      style="width: 100%">
                <el-table-column v-for="header in table.headers" :key="header.prop"
                                 :prop="header.prop"
                                 :label="header.label">
                </el-table-column>
            </el-table>
        </div>

        <disclaimer></disclaimer>
        <modal-notice></modal-notice>
    </section>
</template>

<script>
import FrontTable from "@/components/front-mobile-table";
import MeetingView from "@/components/meeting-view";
import Disclaimer from "@/components/disclaimer";
import ModalNotice from "@/components/modal-notice";
import MyMeetingMixin from "@/views/mixins/my-meeting"
import "@/views/scss/my-meeting.scss"

export default {
    name: 'my-meeting',
    mixins: [MyMeetingMixin],
    components: {Disclaimer, MeetingView, FrontTable,ModalNotice},
}
</script>
